<template>
  <el-aside width="3rem" class="minimize" @click="$emit('update:modelValue', !modelValue)">
    <div class="expander-position">
      <div v-if="useLeftSidebar" class="expander-side">
        <font-awesome-icon v-if="modelValue" icon="caret-left" />
        <font-awesome-icon v-else icon="caret-right" />
      </div>
      <div v-else class="expander-side expander-right">
        <font-awesome-icon v-if="modelValue" icon="caret-right" />
        <font-awesome-icon v-else icon="caret-left" />
      </div>
    </div>
  </el-aside>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';

@Component({
  emits: ['update:modelValue'],
})
@Component
export default class ToggleSidebar extends Vue {
  @Prop({ default: true }) modelValue!: boolean;
  @Prop({ default: true }) useLeftSidebar!: boolean;
}
</script>

<style lang="scss" scoped>
.minimize {
  background-color: transparent;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: var(--el-color-info-light-9);
  width: 0;
  //position: absolute;

  .expander-position {
    position: absolute;
  }

  .expander-side {
    background-color: var(--color-sidebar);
    position: relative;
    width: 3rem;
    height: 4rem;
    text-align: center;
    z-index: 10;
    border-radius: 0 0.5rem 0.5rem 0;
    justify-content: center;
    display: flex;
    flex-direction: column;
  }

  .expander-right {
    border-radius: 0.5rem 0 0 0.5rem;
    left: -3rem;
  }
}
</style>
